var jQuery = require('jquery');

window.AG = window.AG || {};
AG.ui = AG.ui || {};

AG.ui.socialmedia = (function ($) {
    "use strict";

    /**
     * A maximum of 23 characters are taken up by Public URLs and a tweet size is 280, less 1 for the space inserted after cursor
     * i.e. MAX_TWEET_LENGTH max starts at 256 since it excludes the referrer URL
     */
    var MAX_TWEET_LENGTH = 256;
    var MAX_TWEET_WITH_VIA_LENGTH = MAX_TWEET_LENGTH - " via @AllanGray".length;
    var MAX_TWEET_WITHOUT_VIA_LENGTH = MAX_TWEET_LENGTH - 3;  // -3 for surrounding quotes and whitespace between quote and URL

    function shortenTweet(suggestedText, includesVia) {
        var text = suggestedText.trim().replace(/(\.\.\.)/g, ''); // Remove starting and trailing ellipses in blockquotes 
        if (includesVia) {
            if (text.length > MAX_TWEET_WITH_VIA_LENGTH) {
                return text.substring(0, MAX_TWEET_WITH_VIA_LENGTH - 4).trim() + "...'"; // -4 for ellipses and quote
            }
        } else {
            if (text.length > MAX_TWEET_WITHOUT_VIA_LENGTH) {
                return text.substring(0, MAX_TWEET_LENGTH - 6).trim() + '...'; // -3 for ellipses and -3 for surrounding quotes and whitespace between quote and URL
            }
        }
        return text;
    }

    var activateSocialMedia = function (referralAreaParam, titleText, summaryText) {
        // Button transition
        $(".share-button").on("click", function (event) {
            $(this).parent().addClass("expanded");
        });

        // Open action in new page
        $(".social-media-links > a:not(.email), blockquote > a").attr("target", "_blank");

        // Common Page Information
        const url = document.URL,
            title = (titleText || $("h1").first().text()).replace(/ +/g, ' '),
            author = $(".avatar").text().trim(),
            referral = "Allan Gray " + (referralAreaParam || "Insights") + ": ",
            by = author ? "by " + author : "",
            facebookAppId = '000000000000000';

        // Bind page contents to widgets
        const $email = $(".email");
        $email.each(function () {
            const emailSubject = $(this).data("subject") || referral + title;
            const emailBody = $(this).data("body") || "Read this interesting article from Allan Gray: " + url;              
            $(this).attr("href",
                "mailto:" +
                "?subject=" + emailSubject +
                "&body=" + emailBody);
        });

        const $twitter = $(".twitter");
        $twitter.each(function () {
            const twitterText = $(this).data("text");
            const twitterTextFormatted = twitterText ? shortenTweet(twitterText, false) : shortenTweet(referral + "'" + title + "' " + by, true);        
            $(this).attr("href", "https://twitter.com/intent/tweet?" +
                "text=" + twitterTextFormatted +
                "&via=AllanGray" +
                "&url=" + url +
                "&original_referer=" + url);
        });

        const $facebook = $(".facebook");
        $facebook.each(function () {

            // TODO: 
            // Facebook sharer url no longer works on iOS devices
            // We would need to use the Facebook SDK to share on iOS devices
            // We currently don't have a Facebook app ID, so we need to remove the link entirely for now on iOS devices          
            if (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
                $(this).remove();
                return;
            }
            
            $(this).attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url));

            // // new url redirect (opens new tab)
            // $(this).attr("href", "https://www.facebook.com/dialog/share?=app_id=" + facebookAppId + "&display=popup&href=" + encodeURIComponent(url)) + "&redirect_uri=" + encodeURIComponent(url);

            // // new Facebook SDK sharer (required sdk include in head and opens in a popup window)
            // $(this).on("click", function (e) {
            //     e.preventDefault();
            //     FB.ui({
            //         display: 'popup',
            //         method: 'share',
            //         href: url,
            //     }, function(response){
            //         // console.log(response);
            //     });
            // });

        });

        const $linkedin = $(".linkedin");
        $linkedin.each(function () {        
            $(this).attr("href", "https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(url));
        });

        // Block quote tweet
        const $blockquote = $("blockquote");
        $blockquote.each(function () {
            var child = $(this).find("a.twitter");
            child.attr("href", "https://twitter.com/intent/tweet?" +
                "text='" + shortenTweet($(this).text()) + "'" +
                "&url=" + url +
                "&original_referer=" + url)
                .attr("target", "_blank");
        });
    };

    return {
        activate: activateSocialMedia
    };

}(jQuery));
